import { createContext } from "react";

export interface ResizerContextProps {
    windowWidth: number;
}

export const defaultResizerContextProps: ResizerContextProps = {
    windowWidth: 0
};

export const ResizerContext = createContext(defaultResizerContextProps);